import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ExternalSpecial} from "../../model/external-special";
import {CurrencyPipe} from "@angular/common";
import {MatIconButton} from "@angular/material/button";
import {SpecialQuote} from "../../model/special-quote";
import {SpecialQuoteService} from "../../services/special-quote.service";
import {StringUtils} from "../../utils/string-utils";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-special-quotes-detail-dialog',
  imports: [
    CurrencyPipe,
    MatProgressSpinner,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './special-quotes-detail-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './special-quotes-detail-dialog.component.css'
})
export class SpecialQuotesDetailDialogComponent {
  readonly dialogRef = inject<MatDialogRef<SpecialQuotesDetailDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);
  private readonly specialQuoteService: SpecialQuoteService = inject(SpecialQuoteService);
  private externalSpecial: ExternalSpecial;
  protected readonly specialQuote = signal<SpecialQuote>(undefined!);
  protected readonly errorMessage = signal<string>(undefined!);
  protected readonly isBusy = signal<boolean>(false);


  constructor() {
    this.isBusy.set(true);
    this.externalSpecial = this.data.externalSpecial as ExternalSpecial;


    this.specialQuoteService.getSpecialQuote(this.externalSpecial.entityId, +this.externalSpecial.externalId).subscribe({
        next: result => {
          this.specialQuote.set(result);
          this.isBusy.set(false);
        },
        error: error => {
          this.handleError(error)
          this.isBusy.set(false);
        }
      }
    );
  }

  public close(): void {
    this.dialogRef.close();
  }

  private handleError(error: any): void {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  protected specialQty(): number {
    return this.externalSpecial.specialQty;
  }

}
